import React, { useEffect, useState } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { Calendar } from 'lucide-react';
import * as actions from './actions';
import { toastError } from '../../utils';
import { API_URL } from '../../constants';
import StatusBadge from '../../components/StatusBadge';
import moment from 'moment';

const leaveTypeLabels = {
  full_day: 'Full Day',
  half_day_morning: 'Morning',
  half_day_afternoon: 'Afternoon',
};

export default function UpcomingLeaves({ setLoader }) {
  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    loadUpcoming();
  }, []);

  const loadUpcoming = () => {
    setLoader(true);
    actions.getUpcomingLeaves()
      .then((res) => {
        setLoader(false);
        setLeaves(res.body || []);
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.message || 'Failed to load upcoming leaves');
      });
  };

  if (leaves.length === 0) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} py={6}>
        <Calendar size={40} color="#2E3247" strokeWidth={1.5} />
        <Typography sx={{ color: '#64748B', fontSize: '0.9rem' }}>No upcoming leaves</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {leaves.map((leave) => (
        <Box
          key={leave.leaveId}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
            borderRadius: '10px',
            backgroundColor: '#1E2130',
            border: '1px solid #2E3247',
            transition: 'all 0.15s ease',
            '&:hover': { borderColor: '#3E4257' },
          }}
        >
          <Avatar
            src={leave.photograph ? `${API_URL}/${leave.photograph}` : undefined}
            sx={{
              width: 40,
              height: 40,
              backgroundColor: '#6C63FF',
              fontSize: '0.9rem',
              fontWeight: 600,
            }}
          >
            {leave.name ? leave.name.charAt(0).toUpperCase() : '?'}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box display="flex" alignItems="center" gap={1} mb={0.3}>
              <Typography sx={{ fontSize: '0.88rem', color: '#F1F5F9', fontWeight: 500 }}>
                {leave.name}
              </Typography>
              <StatusBadge status={leave.status} />
            </Box>
            <Typography sx={{ fontSize: '0.78rem', color: '#94A3B8' }}>
              {moment(leave.leaveDate).format('ddd, DD MMM YYYY')} &middot; {leaveTypeLabels[leave.leaveType] || 'Full Day'}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
